import React, { PureComponent } from 'react';
import cx from 'classnames';
import FacebookLogo from '../../common/images/FacebookLogo';
import KlickLogo from '../../common/KlickLogo';
import { fireGATrackingEvent } from '../../common/utils';
import TwitterLogo from '../../common/images/TwitterLogo';
import InstagramLogo from '../../common/images/InstagramLogo';

import s from './styles/Footer.module.scss';

class Footer extends PureComponent {
  render = () => {
    const year = new Date().getFullYear();
    const { dark } = this.props;

    return (
      <footer className={cx(s.Footer, { [s.dark]: dark })}>
        <div className={s.wrapper}>
          <div className={s.row}>
            <div className={s.logo}>
              <KlickLogo className={s.logoImage} />
            </div>
            <ul className={s.social}>
              <li>
                <a
                  href="https://www.facebook.com/KlickHealth"
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() => {
                    fireGATrackingEvent(
                      'Outbound Links',
                      'Click',
                      'https://www.facebook.com/KlickHealth'
                    );
                  }}
                >
                  <FacebookLogo />
                </a>
              </li>
              <li>
                <a
                  href="https://www.twitter.com/klickhealth"
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() => {
                    fireGATrackingEvent(
                      'Outbound Links',
                      'Click',
                      'https://www.twitter.com/klickhealth'
                    );
                  }}
                >
                  <TwitterLogo />
                </a>
              </li>
              <li>
                <a
                  href="https://www.instagram.com/klick.health/"
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() => {
                    fireGATrackingEvent(
                      'Outbound Links',
                      'Click',
                      'https://www.instagram.com/klick.health/'
                    );
                  }}
                >
                  <InstagramLogo />
                </a>
              </li>
            </ul>
            <div className={s.copyRight}>
              &copy; {year} KLICK&trade;, KLICK&nbsp;HEALTH&reg; and
              SENSEIOS&trade; are trademarks of Klick&nbsp;Inc.{' '}
              <a
                href="https://www.klick.com/privacy"
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => {
                  fireGATrackingEvent(
                    'Outbound Links',
                    'Click',
                    'https://www.klick.com/privacy'
                  );
                }}
              >
                Privacy
              </a>
            </div>
          </div>
        </div>
      </footer>
    );
  };
}

export default Footer;
